export const defaultLocalizationValues = {
    // general localization keys
    aumico_templates_name: 'Name',
    aumico_templates_save: 'Save',
    aumico_templates_cancel: 'Cancel',
    aumico_templates_description: 'Description',
    aumico_templates_caption: 'Caption',
    aumico_templates_subtotal_name: 'Subtotal name',
    aumico_templates_subtotal_scope: 'Subtotal scope',
    aumico_templates_subtotal_position_after: 'Position After',
    // labels and titles
    aumico_templates_list_edit: 'Edit',
    aumico_templates_list_new_template: 'New Template',
    aumico_templates_list_new: '+ New',
    aumico_templates_form_create_template: 'Create Template',
    aumico_templates_form_update_template: 'Update Template',
    aumico_templates_form_account_basis: 'Account Basis',
    aumico_templates_form_legal_form: 'Legal Form',
    aumico_templates_form_cash_and_cash_equivalents: 'Cash and Cash Equivalents',
    aumico_templates_form_profit_of_the_year: 'Profit of the year',
    aumico_templates_form_back_to_templates_list: 'Back to templates list',
    aumico_templates_subtotal_form_subtotal_name: 'Subtotal Name',
    aumico_templates_group_view_add_group: 'Add Group',
    aumico_templates_group_view_add_subtotal: 'Add Subtotal',
    aumico_templates_group_view_add_fli: 'Add Fli',
    aumico_templates_group_list_new_group: 'New Group',
    aumico_templates_group_form_create_group: 'Create Group',
    aumico_templates_group_form_update_group: 'Update Group',
    aumico_templates_group_form_hide_total: 'Hide total',
    aumico_templates_group_form_title: 'Title',
    aumico_templates_group_form_total_name: 'Total Name',
    aumico_templates_group_form_select_option: 'Select atleast one option:',
    aumico_templates_group_form_allow_groups: 'Allow groups',
    aumico_templates_group_form_allow_items: 'Allow items',
    aumico_templates_change_caption_form_name: 'Name',
    aumico_templates_sub_fli_form_fli: 'Choose FLI',
    aumico_templates_sub_fli_form_fli_options_label: 'Choose Fli',
    aumico_templates_template_account_mapping_form_mapped_accounts: 'Mapped Accounts',
    aumico_templates_template_account_mapping_form_collapse_all: 'Collapse all',
    aumico_templates_template_account_mapping_form_expand_all: 'Expand all',
    aumico_templates_account_mapping_form_balance: 'Balance',
    aumico_templates_account_mapping_form_income: 'Income',
    aumico_templates_account_mapping_form_map_sme_account_plan: 'Map According To SME Account Plan',
    aumico_templates_account_mapping_child_form_number: 'No.',
    aumico_templates_account_mapping_child_form_name: 'Name',
    aumico_templates_group_account_mapping_add_more_items: 'Create SubFli',
    aumico_templates_account_mapping_form_transferred_profit_account_name: 'Transferred profit',
    aumico_templates_account_mapping_form_transferred_surplus_account_name: 'Transferred profit',
    aumico_templates_account_mapping_form_map_income_total: 'Map income statement total to balance sheet profit FLI',
    aumico_templates_mapping_remove_group_warning_dialog_text:
        'Removing this group will lead to resetting any other step that uses this group or any item inside this group. Are you sure you want to remove it ?',
    aumico_templates_mapping_remove_item_warning_dialog_text:
        'Removing this item will lead to resetting any other step that uses it. Are you sure you want to remove it ?',

    aumico_editable_account_placeholder_name: 'Name',
    aumico_editable_account_placeholder_number: 'Number',
    aumico_editable_account_placeholder_closing_value: 'Closing Value',
    aumico_editable_account_placeholder_opening_value: 'Opening Value',
    aumico_editable_account_number_unique_validator: 'Account Number should be unique',
    aumico_editable_account_invalid_data_modal_title: 'Invalid Data',
    aumico_editable_account_invalid_data_modal_content:
        'Account name and Number are required and account number should be unique',
    aumico_editable_account_unlock_prior_year_tooltip: 'Unlock prior-year value',

    // error messages
    aumico_templates_form_enter_template_name_error: 'Please enter template name',
    aumico_templates_form_template_name_exists_error: 'Template name already exists',
    aumico_templates_form_select_account_basis_error: 'Please select account basis',
    aumico_templates_combination_exist_error: 'Legal Form and Account basis combination exists',
    aumico_templates_form_select_legal_form_error: 'Please select legal form',
    aumico_templates_subtotal_form_enter_subtotal_name_error: 'Please enter subtotal name',
    aumico_templates_subtotal_form_name_already_exists_error: 'Group item name already exists',
    aumico_templates_subtotal_form_enter_subtotal_description_error: 'Please enter subtotal description',
    aumico_templates_group_form_enter_group_name_error: 'Please enter group name',
    aumico_templates_group_form_name_already_exists_error: 'Group name already exists',
    aumico_templates_group_form_enter_group_title_error: 'Please enter group title',
    aumico_templates_group_form_enter_group_total_name_error: 'Please enter group total name',
    aumico_templates_group_account_mapping_unallowed:
        'Mapping the selected accounts to the desired Fli is not allowed because it contains one or more Subflis',

    // relcasses labels
    aumico_templates_reclass_label_reclass: 'reclass',
    aumico_templates_reclass_label_adjustment: 'adjustment',
    aumico_templates_reclass_label_internal: 'internal',
    aumico_templates_reclass_label_change_in_adjustment: 'change in adjustment',
    aumico_templates_reclass_label_income: 'income',

    aumico_templates_reclass_label_account_number: 'Account Number',
    aumico_templates_reclass_label_in: 'in',
    aumico_templates_reclass_label_total: 'total',
    aumico_templates_income_selection_popup_title: 'Income Accounts',
    aumico_templates_adjustmentAndReclassed_group_form_tooltip: 'Send change of adjustment to specific income account',
    aumico_templates_income_selection_popup_done_btn: 'Done',
} as const;

type PickTypeOfKey<T> = {
    [P in keyof T]: P;
};

// just getting the value of the key
export const localizationKeys = Object.keys(defaultLocalizationValues).reduce((acc, key) => {
    acc[key] = key;
    return acc;
}, {} as PickTypeOfKey<typeof defaultLocalizationValues>);
